<template>
  <div class="menu">
    <div>
      <h2>MIELOUPE {{ env_name }}</h2>
      <ul>
        <li >
          <router-link :to="{ name:'Home' }" class="menu-link"
			@click.prevent="toggleSubmenu(0)" active-class="selected">
            <font-awesome-icon :icon="['fas', 'fa-home']" /> ダッシュボード
          </router-link>
        </li>
        <li>
          <a href="#" @click.prevent="toggleSubmenu(2)">
            <font-awesome-icon :icon="['fas', 'fa-tasks']" /> 獣害対策管理
          </a>
          <ul class="submenu" v-show="isSubmenuVisible[2]">

            <li>
              <router-link :to="{ name:'DamageMap' }" class="menu-link" active-class="selected">
                <font-awesome-icon :icon="['fas', 'fa-map-marker-alt']" /> 獣害対策（地図）
              </router-link>
            </li>
            <li>
              <router-link :to="{ name:'DamageList' }" class="menu-link" active-class="selected">
                <font-awesome-icon :icon="['fas', 'fa-list']" /> 被害と生息一覧
              </router-link>
            </li>
            <li>
              <router-link :to="{ name:'MeasureList' }" class="menu-link" active-class="selected">
                <font-awesome-icon :icon="['fas', 'fa-list']" /> 妨獣害対策一覧
              </router-link>
            </li>

          </ul>
        </li>
        <br>
        <hr>
        <li v-if="section && (section.startsWith('00'))
			&& section.endsWith('00')">
          <a href="#" @click.prevent="toggleSubmenu(1)">
            <font-awesome-icon :icon="['fas', 'fa-tasks']" /> 行政機関管理
          </a>
          <ul class="submenu" v-show="isSubmenuVisible[1]">
            <li v-if="section=='0000'">
              <router-link :to="{ name:'GroupRegist' }"
				class="menu-link" active-class="selected">
				行政機関の登録
              </router-link>
            </li>
            <li>
              <router-link :to="{ name:'GroupEdit' }"
				class="menu-link" active-class="selected">
				行政機関の編集
              </router-link>
            </li>
          </ul>
        </li>
		<!-- 2026/06/12 RFJ R.Komatsu -->
        <li v-if="section!='9999'">
          <a href="#" @click.prevent="toggleSubmenu(3)">
            <font-awesome-icon :icon="['fas', 'fa-tasks']" /> 利用者管理
          </a>
          <ul class="submenu" v-show="isSubmenuVisible[3]">
            <li>
              <router-link :to="{ name:'UserInfo' }"
				class="menu-link" active-class="selected">
				利用者の表示
              </router-link>
            </li>
            <li v-if="section.endsWith('0')">
              <router-link :to="{ name:'UserRegist' }"
				class="menu-link" active-class="selected">
				利用者の登録
              </router-link>
            </li>
            <li>
              <router-link :to="{ name:'UserEdit' }"
				class="menu-link" active-class="selected">
				利用者の編集
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <br>
    <!-- ログアウトボタン -->
    <button class="logout-button" @click="logout">
      <i class="fas fa-sign-out-alt"></i> ログアウト
    </button>
  </div>
</template>

<script>
//import "@/assets/styles/TheMenuBar.css";

export default {
  data() {
    return {
      env_name: `${process.env.VUE_APP_MODE!='staging' ?'' :'検証'}`,
      isSubmenuVisible: { 1: false, 2: false, 3: false },
      section: localStorage.getItem("section") || "", // 利用者区分を取得
    };
  },
  methods: {
    refresh(to) {
		this.$router.replace(to);
	},
    toggleSubmenu(index) {
      // 指定されたサブメニューの表示・非表示をトグルし、他は閉じる
      this.isSubmenuVisible[1]=index==1 ?!this.isSubmenuVisible[1] :false;
      this.isSubmenuVisible[2]=index==2 ?!this.isSubmenuVisible[2] :false;
      this.isSubmenuVisible[3]=index==3 ?!this.isSubmenuVisible[3] :false;
      /*** 意味不明、機能する事を確認していない
      this.isSubmenuVisible = {
        ...this.isSubmenuVisible,
        [index]: !this.isSubmenuVisible[index],
      };
	  ***/
    },
    logout() {
      try {
        localStorage.removeItem("jwtToken");
        localStorage.removeItem("section");
        this.$router.push({ name: 'Login' });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.menu {
    width: 15%;
    background-color: #d4f1c5;
    padding: 20px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-right: 2px solid #7ba596;
    display: block;
    flex-direction: column;
    justify-content: space-between;
  }
  
  .menu-link {}
  .menu h2 {
    margin-bottom: 20px;
    font-size: 20px;
    color: #333;
    letter-spacing: 1px;
  }
  
  .menu ul {
    list-style-type: none;
    padding: 0;
  }
  
  .menu ul li {
    margin-bottom: 10px;
  }
  
  .menu ul li ul {
    margin-left: 20px;
    margin-top: 10px;
  }
  
  .menu a {
    text-decoration: none;
    color: black;
    display: block;
    padding: 10px;
    background-color: #8cd659;
    border-radius: 4px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.3s ease, background-color 0.3s ease;
  }
  
  .menu a.selected {
    background-color: #ade830;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
  }
  
  .menu a:not(.selected):hover {
    background-color: #ade830;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
  }
  
  .submenu {
    padding-left: 20px;
  }
  
  .submenu a {
    background-color: #d3d3d3;
  }
  
  .logout-button {

    width: auto;
    background-color: #4caf50;
    color: white;
    border: none;
    padding: 10px 20px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    border-radius: 5px;
    display: block;
    margin: 20px auto ;
    font-size: 15px;
    font-weight: bold; 
    background-color: #d4f1c5;
    padding: 10px;
    color: black;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    display: flex;
    white-space: nowrap;
    transition: background-color 0.3s ease;
  }
  
  .logout-button:hover {
    background-color: #d4f1c5;
  }
</style>
